import { render, staticRenderFns } from "./AddressesCreate.vue?vue&type=template&id=557f6a90&scoped=true&"
import script from "./AddressesCreate.vue?vue&type=script&lang=ts&"
export * from "./AddressesCreate.vue?vue&type=script&lang=ts&"
import style0 from "./AddressesCreate.vue?vue&type=style&index=0&id=557f6a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557f6a90",
  null
  
)

export default component.exports